<div class="chatbot-body" [class.chatbot-body-dashboard]="dashboardWidget" [style.font-size.px]="fontSize">
  <div *ngIf="dashboardWidget && messages.length === 0 && !isLoading" class="chatbot-welcome">
    <p class="chatbot-welcome-title">How can I help you today?</p>
    <p class="chatbot-welcome-hint">Try asking about meetings, company data, or schedules. Quick-reply buttons will appear when DigiBot needs your input.</p>
    <div class="chatbot-welcome-suggestions">
      <button type="button" class="chat-welcome-chip" (click)="onFollowUpQuestion({ text: 'Schedule a meeting' }, { role: 'bot', content: '' })">
        Schedule a meeting
      </button>
      <button type="button" class="chat-welcome-chip" (click)="onFollowUpQuestion({ text: 'View my pending tasks' }, { role: 'bot', content: '' })">
        View my pending tasks
      </button>
    </div>
  </div>

  <div *ngFor="let msg of messages; let i = index" class="chat-message-wrap">
    <div [ngClass]="msg.role" class="chat-message-bubble">{{ msg.content }}</div>

    <div *ngIf="msg.role === 'bot' && hasMeetingDetails(msg.meetingDetails)" class="meeting-details-card">
      <div class="meeting-details-title">Meeting summary</div>
      <dl class="meeting-details-list mb-0">
        <ng-container *ngIf="msg.meetingDetails.summary">
          <dt>Summary</dt>
          <dd>{{ msg.meetingDetails.summary }}</dd>
        </ng-container>
        <ng-container *ngIf="msg.meetingDetails.meeting_type">
          <dt>Type</dt>
          <dd>{{ msg.meetingDetails.meeting_type }}</dd>
        </ng-container>
        <ng-container *ngIf="msg.meetingDetails.start_date">
          <dt>Date</dt>
          <dd>{{ msg.meetingDetails.start_date }}</dd>
        </ng-container>
        <ng-container *ngIf="msg.meetingDetails.start_time || msg.meetingDetails.end_time">
          <dt>Time</dt>
          <dd>
            <span *ngIf="msg.meetingDetails.start_time">{{ msg.meetingDetails.start_time }}</span>
            <span *ngIf="msg.meetingDetails.start_time && msg.meetingDetails.end_time"> – </span>
            <span *ngIf="msg.meetingDetails.end_time">{{ msg.meetingDetails.end_time }}</span>
          </dd>
        </ng-container>
        <ng-container *ngIf="msg.meetingDetails.attendees">
          <dt>Attendees</dt>
          <dd>{{ msg.meetingDetails.attendees }}</dd>
        </ng-container>
        <ng-container *ngIf="msg.meetingDetails.agenda">
          <dt>Agenda</dt>
          <dd>{{ msg.meetingDetails.agenda }}</dd>
        </ng-container>
      </dl>
    </div>

    <!-- Meeting type: always dropdown when contextual_data.meeting_type_options is present -->
    <div *ngIf="msg.role === 'bot' && isLatestBotMessage(i) && !msg.optionsDisabled && hasMeetingTypeOptions(msg.contextualData)"
      class="chat-options chat-options-contextual">
      <span class="chat-options-label">Meeting type</span>
      <select class="chat-options-select" [disabled]="isLoading"
        [ngModel]="selectedMeetingTypeByIndex[i]"
        (change)="onMeetingTypeSelect($any($event.target).value, msg, i)">
        <option value="">Select meeting type...</option>
        <option *ngFor="let opt of msg.contextualData.meeting_type_options" [value]="opt.id"
          [title]="opt.description || opt.label">
          {{ opt.label }}
        </option>
      </select>
    </div>

    <!-- Date + time on one row when both arrays are empty -->
    <div *ngIf="msg.role === 'bot' && isLatestBotMessage(i) && !msg.optionsDisabled && showCombinedDateTimePickers(msg)"
      class="chat-input-picker chat-input-picker--combined">
      <label class="chat-input-picker__label">Choose date and time</label>
      <div class="chat-input-picker__row chat-input-picker__row--combined">
        <input type="date" class="chat-input-picker__field" [(ngModel)]="dateInputByIndex[i]" [disabled]="isLoading"
          aria-label="Meeting date">
        <input type="time" class="chat-input-picker__field" [(ngModel)]="timeInputByIndex[i]" [disabled]="isLoading"
          aria-label="Meeting time">
        <button type="button" class="chat-input-picker__btn" [disabled]="isLoading || !canSubmitCombined(i, msg)"
          (click)="submitDateAndTime(i, msg)">Send</button>
      </div>
    </div>

    <!-- Date only: empty date_options → calendar; non-empty → quick options -->
    <ng-container *ngIf="msg.role === 'bot' && isLatestBotMessage(i) && !msg.optionsDisabled && !showCombinedDateTimePickers(msg)">
      <div *ngIf="needsDatePicker(msg.contextualData)" class="chat-input-picker">
        <label class="chat-input-picker__label">Choose date</label>
        <div class="chat-input-picker__row">
          <input type="date" class="chat-input-picker__field" [(ngModel)]="dateInputByIndex[i]" [disabled]="isLoading">
          <button type="button" class="chat-input-picker__btn" [disabled]="isLoading || !dateInputByIndex[i]"
            (click)="submitDate(i, msg)">Send</button>
        </div>
      </div>

      <div *ngIf="hasDateQuickOptions(msg.contextualData)" class="chat-options chat-options-contextual">
        <span class="chat-options-label">Date options</span>
        <div class="chat-options-buttons" *ngIf="!useDropdown(msg.contextualData.date_options); else dateOptionsDropdownTpl">
          <button *ngFor="let opt of msg.contextualData.date_options" type="button"
            class="chat-option-btn chat-option-date" [disabled]="isLoading" (click)="onDateQuickOption(opt, msg, i)"
            [title]="opt.description || opt.label">
            {{ opt.label }}
          </button>
        </div>
        <ng-template #dateOptionsDropdownTpl>
          <select class="chat-options-select" [disabled]="isLoading"
            [ngModel]="selectedDateValueByIndex[i]"
            (change)="onDateOptionSelect($any($event.target).value, msg, i)">
            <option value="">Select date...</option>
            <option *ngFor="let opt of msg.contextualData.date_options" [value]="opt.id"
              [title]="opt.description || opt.label">
              {{ opt.label }}
            </option>
          </select>
        </ng-template>
      </div>

      <div *ngIf="needsTimePicker(msg.contextualData)" class="chat-input-picker">
        <label class="chat-input-picker__label">Choose time</label>
        <div class="chat-input-picker__row">
          <input type="time" class="chat-input-picker__field" [(ngModel)]="timeInputByIndex[i]" [disabled]="isLoading">
          <button type="button" class="chat-input-picker__btn" [disabled]="isLoading || !timeInputByIndex[i]"
            (click)="submitTime(i, msg)">Send</button>
        </div>
      </div>

      <div *ngIf="hasTimeQuickOptions(msg.contextualData)" class="chat-options chat-options-contextual">
        <span class="chat-options-label">Time options</span>
        <div class="chat-options-buttons" *ngIf="!useDropdown(msg.contextualData.time_options); else timeOptionsDropdownTpl">
          <button *ngFor="let opt of msg.contextualData.time_options" type="button"
            class="chat-option-btn chat-option-time" [disabled]="isLoading" (click)="onTimeQuickOption(opt, msg, i)"
            [title]="opt.description || opt.label">
            {{ opt.label }}
          </button>
        </div>
        <ng-template #timeOptionsDropdownTpl>
          <select class="chat-options-select" [disabled]="isLoading"
            [ngModel]="selectedTimeValueByIndex[i]"
            (change)="onTimeOptionSelect($any($event.target).value, msg, i)">
            <option value="">Select time...</option>
            <option *ngFor="let opt of msg.contextualData.time_options" [value]="opt.id"
              [title]="opt.description || opt.label">
              {{ opt.label }}
            </option>
          </select>
        </ng-template>
      </div>
    </ng-container>
    <div *ngIf="msg.role === 'bot' && isLatestBotMessage(i) && !msg.optionsDisabled && isCompositeMeetingForm(msg)"
      class="chat-input-picker">
      <button type="button" class="chat-input-picker__btn"
        [disabled]="isLoading || !canSubmitContextualForm(i, msg)"
        (click)="submitContextualForm(i, msg)">
        Submit details
      </button>
    </div>

    <div *ngIf="msg.role === 'bot' && msg.recommendedAnswers?.length && !msg.optionsDisabled"
      class="chat-options chat-options-recommended">
      <span class="chat-options-label">Quick replies</span>
      <div class="chat-options-buttons" *ngIf="!useDropdown(msg.recommendedAnswers); else recommendedDropdownTpl">
        <button *ngFor="let opt of msg.recommendedAnswers" type="button" class="chat-option-btn"
          [ngClass]="optionCategoryClass(opt.category)" [disabled]="isLoading"
          (click)="onRecommendedAnswer(opt, msg)">
          <span *ngIf="opt.icon" class="chat-option-icon" aria-hidden="true">{{ opt.icon }}</span>
          {{ opt.text }}
        </button>
      </div>
      <ng-template #recommendedDropdownTpl>
        <select class="chat-options-select" [disabled]="isLoading"
          (change)="onRecommendedDropdownChange($any($event.target).value, msg)">
          <option value="">Select quick reply...</option>
          <option *ngFor="let opt of msg.recommendedAnswers; let idx = index" [value]="idx">
            {{ opt.text }}
          </option>
        </select>
      </ng-template>
    </div>

    <div *ngIf="msg.role === 'bot' && msg.followUpQuestions?.length && !msg.optionsDisabled"
      class="chat-options chat-options-followup">
      <span class="chat-options-label">Suggestions</span>
      <div class="chat-options-buttons" *ngIf="!useDropdown(msg.followUpQuestions); else followUpDropdownTpl">
        <button *ngFor="let fq of msg.followUpQuestions" type="button" class="chat-option-btn chat-option-followup"
          [disabled]="isLoading" (click)="onFollowUpQuestion(fq, msg)">
          {{ fq.text }}
        </button>
      </div>
      <ng-template #followUpDropdownTpl>
        <select class="chat-options-select" [disabled]="isLoading"
          (change)="onFollowUpDropdownChange($any($event.target).value, msg)">
          <option value="">Select suggestion...</option>
          <option *ngFor="let fq of msg.followUpQuestions; let idx = index" [value]="idx">
            {{ fq.text }}
          </option>
        </select>
      </ng-template>
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-message">
    <div class="typing-indicator">DigiBot is typing...</div>
  </div>
</div>
